{
  "alias": {
    "react-inlinesvg/provider": "react-inlinesvg/dist/provider.js"
  },
  "author": "rmkubik",
  "browserslist": "> 0.5%, last 2 versions, not dead",
  "dependencies": {
    "@parcel/resolver-glob": "^2.16.4",
    "common-tags": "^1.8.2",
    "compare-versions": "^6.1.0",
    "date-fns": "^2.30.0",
    "howler": "^2.2.4",
    "lodash.merge": "^4.6.2",
    "mobx": "^6.7.0",
    "mobx-react-lite": "^3.4.0",
    "mobx-state-tree": "^5.1.7",
    "normalize.css": "^8.0.1",
    "parcel": "^2.16.4",
    "process": "^0.11.10",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-inlinesvg": "^4.1.1",
    "seedrandom": "^3.0.5",
    "styled-components": "^5.3.6",
    "zod": "3.22.4"
  },
  "description": "",
  "devDependencies": {
    "@types/bun": "^1.0.8",
    "@types/common-tags": "^1.8.1",
    "@types/howler": "^2.2.11",
    "@types/json-stable-stringify": "^1.0.36",
    "@types/lodash.merge": "^4.6.7",
    "@types/ramda": "^0.29.11",
    "@types/react": "^18.0.26",
    "@types/react-dom": "^18.0.9",
    "@types/seedrandom": "^3.0.4",
    "@types/styled-components": "^5.1.26",
    "bun": "^1.1.30",
    "chalk": "^5.3.0",
    "http-server": "^14.1.1",
    "json-stable-stringify": "^1.1.1",
    "ramda": "^0.29.1"
  },
  "engines": {
    "node": ">=22.0.0"
  },
  "license": "UNLICENSED",
  "name": "cluefinder",
  "scripts": {
    "build": "parcel build src/index.html",
    "fakeAmuServer": "http-server tests/data --cors",
    "generateConfigFile": "bun scripts/generateConfigFile.ts",
    "start": "parcel src/index.html -p 3000"
  },
  "version": "1.28.1"
}
